import React from "react";
import { ContentPage } from 'modules2/content-page';
import {GenresPodCastCard} from "./components";
import container from "./GenresPodCast.container";

const GenresPodCast = (props) => {
    const {
        podcastState: { currentGenres, genres },
    } = props;
    const genreName = genres.filter((e) => e.id === currentGenres).map(genres => genres.name);
    return (
        <ContentPage
            header={{
                title: `Podcast List ${genres ? '(' +genreName+')' : ''}`,
                // title: `Podcast List ${'(' +currentGenres+')'}`,
                description: '',
                controls: '',
            }}
            body={<GenresPodCastCard />}
        />
    );
};

export default container(GenresPodCast);